import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "CloseMini",
  "use": "CloseMini-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"CloseMini\"><g fill-rule=\"evenodd\"><path d=\"M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-1.929A7.071 7.071 0 1 0 9 1.93a7.071 7.071 0 0 0 0 14.14z\" /><path d=\"M5.38 6.28L6.46 5.2l2.565 2.564 2.7-2.565 1.08 1.08-2.7 2.565 2.7 2.7-1.08 1.08-2.7-2.7-2.565 2.7-1.08-1.08 2.565-2.7z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol